module.exports = __webpack_public_path__ + "img/3_degrees.5badd9ae.png";